export const UPDATE_USER = "UPDATE_USER";
export const ID_EMPRESA = "ID_EMPRESA";
export const RESET_USER = "RESET_USER";
